import type { DocumentCategory } from "@/adapters/api";
import type { DocumentCounts } from "../../types.ts";
import {
	DOCUMENT_CATEGORIES,
	documentCategoryLabel,
} from "../../utils/categories.ts";
import { totalDocuments } from "../../utils/map.ts";

interface CategoryFilterProps {
	value: DocumentCategory | undefined;
	counts: DocumentCounts | undefined;
	onChange: (category: DocumentCategory | undefined) => void;
}

function FilterChip({
	label,
	count,
	active,
	onClick,
}: {
	label: string;
	count: number | undefined;
	active: boolean;
	onClick: () => void;
}) {
	return (
		<button
			type="button"
			className="document-filter__chip"
			data-active={active}
			aria-pressed={active}
			onClick={onClick}
		>
			<span>{label}</span>
			{count !== undefined && (
				<span className="document-filter__count">{count}</span>
			)}
		</button>
	);
}

export function CategoryFilter({
	value,
	counts,
	onChange,
}: CategoryFilterProps) {
	return (
		<fieldset className="document-filter" aria-label="Filtrar por categoria">
			<FilterChip
				label="Todos"
				count={counts ? totalDocuments(counts) : undefined}
				active={!value}
				onClick={() => onChange(undefined)}
			/>
			{DOCUMENT_CATEGORIES.map((category) => (
				<FilterChip
					key={category}
					label={documentCategoryLabel(category)}
					count={counts?.[category]}
					active={value === category}
					onClick={() => onChange(category)}
				/>
			))}
		</fieldset>
	);
}
